import { useContext } from "react";
import { DTHoverStateContext } from "./DTHoverContext";

export function useDTHoverStateContext() {
  const state = useContext(DTHoverStateContext);
  return {
    getIsHovered: (columnId: string) => {
      // If a resize is in progress, the column is not considered hovered
      return state.hoveredColumnId === columnId && !state.resizingColumnId;
    },
    hoveredColumnId: state.hoveredColumnId,
  };
}
